import { Amplify } from 'aws-amplify';

let amplifyConfigured = false;

export interface AmplifyCognitoConfig {
  userPoolId: string;
  userPoolClientId: string;
}

/**
 * Configure Amplify after /api/public/bootstrap returns Cognito settings.
 */
export function configureAmplify(cognito: AmplifyCognitoConfig): void {
  if (amplifyConfigured) {
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: cognito.userPoolId,
        userPoolClientId: cognito.userPoolClientId,
        loginWith: {
          email: true,
        },
        userAttributes: {
          email: {
            required: true,
          },
          given_name: {
            required: true,
          },
          family_name: {
            required: true,
          },
        },
        passwordFormat: {
          minLength: 8,
          requireLowercase: true,
          requireUppercase: true,
          requireNumbers: true,
          requireSpecialCharacters: true,
        },
        signUpVerificationMethod: 'code',
      },
    },
  });

  amplifyConfigured = true;
}

export default Amplify;
